// extracted by mini-css-extract-plugin
export default {"RightsPage":"page_RightsPage__y01Xr","container":"page_container__U1D7b","box":"page_box__irke4"};